import React from 'react';
export function Footer() {
  return <footer className="bg-[#05020c] py-12 border-t border-white/5 relative z-10" data-id="element-47">
      <div className="container mx-auto px-4 text-center" data-id="element-48">
        <h3 className="font-cinzel font-bold text-2xl text-white/80 mb-6" data-id="element-49">
          ENERGIA <span className="text-[#fbbf24]" data-id="element-50">CUANTICA</span>
        </h3>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-white/40 mb-8" data-id="element-51">
          <a href="#" className="hover:text-white/80 transition-colors" data-id="element-52">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white/80 transition-colors" data-id="element-53">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white/80 transition-colors" data-id="element-54">
            Contacto
          </a>
        </div>

        <p className="text-xs text-white/30" data-id="element-55">
          Este producto no sustituye el asesoramiento profesional. Los
          resultados pueden variar según la dedicación y práctica de cada
          individuo.
          <br className="hidden md:block" data-id="element-56" />© {new Date().getFullYear()}{' '}
          Energia Cuantica PRO KIT. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}